import { Box, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { AppContainer } from './Container';
import { AppPaper } from './Paper';

export const AppTrialCreated = () => {
	const { t } = useTranslation();

	return (
		<AppContainer>
			<AppPaper>
				<Box display="flex" flexDirection="column" justifyContent="center" alignItems="center">
					<Typography variant="h5">{t('trial_creation_success')}</Typography>
					<Typography variant="p">{t('check_email')}</Typography>

					<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
						<div>
							<h3>{t('download_now_available')}</h3>
						</div>
						<div>
							<a href="https://apps.apple.com/sa/app/lazywait-pos-point-of-sale/id1570090197" target="_blank">
								Apple
							</a>
						</div>
						<div>
							<a href="https://play.google.com/store/apps/details?id=com.cloudapps.pos5&hl=en&gl=US" target="_blank">
								Android
							</a>
						</div>
						<div>
							<a href="https://appgallery.huawei.com/#/app/C103398635" target="_blank">
								Huawei
							</a>
						</div>
						<div>
							<a href="https://apps.microsoft.com/detail/9nb67c7ct8d0?hl=ar-SA&gl=SA" target="_blank">
								Windows
							</a>
						</div>
					</div>
					<br />
					<br />
				</Box>
			</AppPaper>
		</AppContainer>
	);
};
